import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	downloadingCsvFile: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	downloadingProgressBarAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	downloadingCsvFile: {
		id: 'issue-navigator-action-export-issues.common.download-flag.downloading-csv-file',
		defaultMessage: 'Downloading {fileExtension} file',
		description: 'Label that indicates downloading is in progress',
	},
	downloadingProgressBarAriaLabel: {
		id: 'issue-navigator-action-export-issues.common.download-flag.downloading-progress-bar-aria-label',
		defaultMessage: 'Downloading in progress',
		description: 'Aria label for the indeterminate progress bar',
	},
});

export default messages;
